"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var lastAction_exports = {};
__export(lastAction_exports, {
  getLastAction: () => getLastAction,
  setLastAction: () => setLastAction
});
module.exports = __toCommonJS(lastAction_exports);
var lastUserRouteAction = Date.now();
var getLastAction = function getLastAction2() {
  return lastUserRouteAction;
};
var setLastAction = function setLastAction2() {
  lastUserRouteAction = Date.now();
};
//# sourceMappingURL=lastAction.js.map
